import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckIcon, LockIcon } from './Icons';
export function OfferSection() {
  return <section id="offer-section" className="bg-olive text-cream py-24 px-4 relative overflow-hidden" data-id="element-173">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(197,165,90,0.15),transparent_60%)]" data-id="element-174" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-176">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-177">
            Te presento INTIMIDAD RADICAL
          </h2>
          <p className="text-xl text-cream/80 max-w-2xl mx-auto" data-id="element-178">
            No es solo un curso o un libro más; es una inmersión profunda
            diseñada para reconstruir tu relación con Dios desde cero.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white text-dark rounded-2xl overflow-hidden shadow-2xl max-w-3xl mx-auto" data-id="element-179">
          <div className="bg-dark text-cream p-8 text-center" data-id="element-180">
            <h3 className="text-2xl font-bold mb-2" data-id="element-181">
              El Protocolo Completo de 30 Días
            </h3>
            <p className="text-gold" data-id="element-182">Ebook Principal + Sistema Paso a Paso</p>
          </div>

          <div className="p-8 md:p-12" data-id="element-183">
            <ul className="space-y-4 mb-12" data-id="element-184">
              {['Los 3 Pilares Fundamentales', 'El Método de los 3 Filtros', 'Plan diario semana a semana', 'Prácticas para superar el ruido mental', 'Guía para sanar heridas religiosas'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg" data-id="element-185">
                  <CheckIcon className="w-6 h-6 text-olive flex-shrink-0" data-id="element-186" />
                  <span data-id="element-187">{item}</span>
                </li>)}
            </ul>

            <div id="pricing-area" className="text-center border-t border-dark/10 pt-8" data-id="element-188">
              <p className="text-dark/50 font-bold mb-2 uppercase tracking-wide" data-id="element-189">
                Valor Real
              </p>
              <p className="text-4xl font-serif text-dark/40 line-through decoration-accent-red mb-4" data-id="element-190">
                $97.00
              </p>

              <div className="inline-block bg-accent-red text-white text-sm font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-6" data-id="element-191">
                90% de descuento — Solo hoy
              </div>

              <div className="bg-olive/5 rounded-xl p-6 mb-8 border-2 border-olive/30 relative" data-id="element-192">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-dark text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-193">
                  Precio de lanzamiento
                </div>
                <p className="text-dark/70 mb-4 mt-2" data-id="element-194">
                  No vas a pagar $97. Ni siquiera los $197 que cuesta un
                  seminario teológico que te llenará la cabeza y dejará el
                  corazón vacío. Porque mi misión es que cada creyente sediento
                  recupere su conexión con el Padre.
                </p>
                <p className="text-sm font-bold text-accent-red uppercase tracking-wider mb-2" data-id="element-195">
                  Tu Inversión Hoy:
                </p>
                <div className="text-6xl md:text-7xl font-bold text-olive mb-1" data-id="element-196">
                  $9.87
                </div>
                <p className="text-sm text-dark/60 uppercase tracking-widest mb-1" data-id="element-197">
                  (Pago Único)
                </p>
                <p className="text-xs text-olive font-semibold" data-id="element-198">
                  Ahorras $87.13
                </p>
              </div>

              <div className="flex flex-col items-center gap-4" data-id="element-199">
                <CTAButton className="w-full md:w-auto" href="https://coresolutionsg.com/cart/47581083304123:1" data-id="element-200" />

                <div className="flex items-center gap-2 text-sm text-dark/60 mt-4" data-id="element-201">
                  <LockIcon className="w-4 h-4" data-id="element-202" />
                  <span data-id="element-203">Pago 100% Seguro. Acceso Inmediato y Permanente.</span>
                </div>
                <p className="text-sm text-dark/60" data-id="element-204">
                  No hay suscripción. No hay pagos recurrentes.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-dark text-cream/70 py-3 px-6 text-center text-sm tracking-wide border-t border-white/5" data-id="element-205">
            <span data-id="element-206">Precio exclusivo de lanzamiento</span>
            <span className="mx-2 text-gold/40" data-id="element-207">·</span>
            <span data-id="element-208">Disponibilidad limitada</span>
          </div>
        </motion.div>
      </div>
    </section>;
}